/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AvatarsControllerRedirectToAvatarQueryResponse, AvatarsControllerRedirectToAvatarPathParams } from "../../models/avatarsController/AvatarsControllerRedirectToAvatar";

function getAvatarsControllerRedirectToAvatarUrl(id: AvatarsControllerRedirectToAvatarPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/avatars/${id}` as const }  
  return res
}

/**
 * @summary Redirect to a user avatar image (public; id is a principal or user id)
 * {@link /api/v1/avatars/:id}
 */
export async function avatarsControllerRedirectToAvatar(id: AvatarsControllerRedirectToAvatarPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AvatarsControllerRedirectToAvatarQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAvatarsControllerRedirectToAvatarUrl(id).url.toString(), ... requestConfig })  
  return res.data
}